"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHtmlNotificationResultsTaskInfo = exports.getHtmlNotificationResultsPath = exports.getAuthoringTaskInfo = exports.getAuthoringPath = exports.getMeetingSurveyTakingTaskInfo = exports.getMeetingSurveyTakingPath = exports.getDashboardContentPath = void 0;
function getDashboardContentPath(base, applicationType, themeName) {
    return `${base}/${applicationType}/content/personal/dashboard?theme=${themeName}`;
}
exports.getDashboardContentPath = getDashboardContentPath;
function getMeetingSurveyTakingPath(base, applicationType, surveyId, surveyType, allowRetake) {
    return `${base}/${applicationType}/content/meeting/${surveyType}/${encodeURIComponent(surveyId)}${allowRetake ? "?allowRetake=true" : ""}`;
}
exports.getMeetingSurveyTakingPath = getMeetingSurveyTakingPath;
function getMeetingSurveyTakingTaskInfo(base, survey, allowRetake) {
    return {
        url: getMeetingSurveyTakingPath(base, survey.applicationType, survey.id, survey.type, allowRetake),
        width: 460,
        height: 320,
    };
}
exports.getMeetingSurveyTakingTaskInfo = getMeetingSurveyTakingTaskInfo;
function getAuthoringPath(base, surveyType, applicationType = "msteams", options) {
    let uri;
    if (options === null || options === void 0 ? void 0 : options.scheduleId) {
        uri = `${base}/${applicationType}/content/polly/series/${options.scheduleId}/edit`;
        delete options.scheduleId;
    }
    else {
        uri = `${base}/${applicationType}/content/${surveyType}/authoring`;
    }
    if (options) {
        const params = new URLSearchParams(options);
        uri += `?${params.toString()}`;
    }
    return uri;
}
exports.getAuthoringPath = getAuthoringPath;
var DialogDimension;
(function (DialogDimension) {
    DialogDimension["Large"] = "large";
    DialogDimension["Medium"] = "medium";
    DialogDimension["Small"] = "small";
})(DialogDimension || (DialogDimension = {}));
function getAuthoringTaskInfo(base, surveyType, applicationType = "msteams", options) {
    var _a;
    const url = getAuthoringPath(base, surveyType, applicationType, options);
    return {
        url,
        size: { width: 700, height: DialogDimension.Large },
        title: (_a = options === null || options === void 0 ? void 0 : options.title) !== null && _a !== void 0 ? _a : "Polly authoring",
    };
}
exports.getAuthoringTaskInfo = getAuthoringTaskInfo;
function getHtmlNotificationResultsPath(base, applicationType, surveyId, notificationType) {
    let subPath;
    switch (notificationType) {
        case "quiz-leaderboard":
            subPath = `meeting/survey/${encodeURIComponent(surveyId)}/results/quiz/leaderboard`;
            break;
        case "qna-notification":
            subPath = `meeting/survey/${encodeURIComponent(surveyId)}/results/qna/notification`;
            break;
        case "quiz-personal":
            subPath = `meeting/survey/${encodeURIComponent(surveyId)}/results/quiz/personal`;
            break;
        case "icebreaker":
            subPath = `meeting/survey/${encodeURIComponent(surveyId)}/results/icebreaker`;
            break;
        case "hot-take":
            subPath = `meeting/survey/${encodeURIComponent(surveyId)}/results/hot-take`;
            break;
        default:
            throw Error(`unknown notification type: ${notificationType}`);
    }
    return `${base}/${applicationType}/content/${subPath}`;
}
exports.getHtmlNotificationResultsPath = getHtmlNotificationResultsPath;
function getHtmlNotificationResultsTaskInfo(base, survey, notificationType) {
    return {
        url: getHtmlNotificationResultsPath(base, survey.applicationType, survey.id, notificationType),
        height: 500,
        width: 460,
        title: survey.title,
    };
}
exports.getHtmlNotificationResultsTaskInfo = getHtmlNotificationResultsTaskInfo;
//# sourceMappingURL=contentPaths.js.map